<template>
  <vxe-table
    border
    stripe
    round
    show-overflow
    show-header-overflow
    :export-config="{}"
    :keyboard-config="{isArrow: true}"
    align="center"
    ref="table"
    :data="data"
    :loading="loading"
    :height="scrollY"
    :checkbox-config="{checkRowKeys: defaultSelecteRows, highlight: true,checkField: 'checked', trigger: 'row'}"
    :radio-config="{labelField: 'name'}"
    :column-config="{resizable: true}"
    :row-config="{isCurrent: true, isHover: true}"
    size="mini">
    <vxe-table-column type="checkbox" width="50"></vxe-table-column>
    <vxe-table-column title="business.label.index" type="seq" width="50" />
    <vxe-table-column field="barcode.no" sortable title="business.label.barcode" width="100"/>
    <vxe-table-column field="order.no" sortable title="business.label.orderNo" width="120" />
    <vxe-table-column field="pickingOrder.no" sortable title="business.label.pickingOrderNo" width="150" />
    <vxe-table-column field="type" sortable title="business.label.type" width="150" />
  </vxe-table>
</template>
<script>
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import { findAll } from '@/api/Api'
import { getOutBoundReplenishData } from '@/pdaView/utils'

export default {
    name: 'ReplenishTag',
    data() {
      return {
        defaultSelecteRows: [],
        loading: false,
        data: [],
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.845)// 表格竖向滚动条,减去的数值是页面其他元素的高度
      }
    },
    methods: {
      getData(body) {
        this.loading = true
        findAll('shipmentCommandBarcodeFactory', body).then(res => {
          if (res.success) {
            this.data = res.result
          }
        }).finally(() => {
          this.loading = false
        })
      },
      print() {
        let list = this.$refs.table.getCheckboxRecords()
        _.forEach(list, item => {
          let body = {
            'query.no': 'replenishTagPrint',
            'sql': null,
            'args': {
              'barcodeNo': item.barcode.no,
              pickingOrderNo: null
            }
          }
          getOutBoundReplenishData(body)
        })
      }
    },
    mounted() {

    }
  }
</script>